import React, { createContext, useContext, useState, useEffect } from 'react';

const LoadingContext = createContext({});
LoadingContext.displayName = 'LoadingContext';

export const useLoadingContext = () => {
  const context = useContext(LoadingContext);
  if (!context) throw new Error(`useLoadingContext must be used within LoadingProvider`);

  return context;
};

export const LoadingProvider = ({ children }) => {
  const [loading, setLoading] = useState(false);

  // AGREGAR ESTE LOG
  useEffect(() => {
    console.log('🔄 LoadingContext - montado/re-montado');
    return () => {
      console.log('🔄 LoadingContext - desmontado');
    };
  }, []);

  // AGREGAR ESTE LOG
  useEffect(() => {
    console.log('🔄 LoadingContext - loading changed:', loading);
  }, [loading]);

  return (
    <LoadingContext.Provider value={{ loading, setLoading }}>{children}</LoadingContext.Provider>
  );
};
